'use strict'
import Vue from 'vue'
import Vuex from 'vuex'
import LoginStore from '../../pages/login/services/login.store.js'
import FrameStore from '../../layouts/main.layout.store.js'
// import EventStore from '../../event/services/event.store.js'
// import ResourceStore from '../../resource/services/resource.store.js'
// import SteyerStore from '../../user/services/steyer.store.js'

Vue.use(Vuex)

export default new Vuex.Store(
  {
    strict: process.env.NODE_ENV !== 'production', // [ext] open vuex strict mode
    modules: {
      login: LoginStore,
      frame: FrameStore
    }
  }
)



// WEBPACK FOOTER //
// ./src/common/provider/store.provider.js